(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["community-video-carousel"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('ks-video-reviews')) {
  class KsVideoReviews extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      this.onLoad = () => this.init();
      if (typeof Flickity === 'undefined') window.addEventListener('load', this.onLoad, { once: true });
      else requestAnimationFrame(this.onLoad);
    }
    init() {
      if (!this.isConnected || this.slider || typeof Flickity === 'undefined') return;
      const track = this.querySelector('[data-vr-track]');
      if (!track || !track.querySelector('.carousel__slide')) return;
      const root = this;
      const sync = function () { root.syncControls(this); };
      this.slider = new Flickity(track, {
        wrapAround: false, cellAlign: document.dir === 'rtl' ? 'right' : 'left',
        pageDots: true, contain: true, groupCells: true, autoPlay: false,
        rightToLeft: document.dir === 'rtl', prevNextButtons: false,
        cellSelector: '.carousel__slide', on: { ready: sync, select: sync, resize: sync }
      });
      const signal = this.events.signal;
      this.querySelector('[data-vr-prev]').addEventListener('click', () => this.slider.previous(), { signal });
      this.querySelector('[data-vr-next]').addEventListener('click', () => this.slider.next(), { signal });
      this.addEventListener('keydown', (event) => {
        const dot = event.target.closest('.flickity-page-dots .dot');
        if (!dot || !['Enter', ' '].includes(event.key)) return;
        event.preventDefault();
        this.slider.select([...dot.parentElement.children].indexOf(dot));
      }, { signal });
      this.addEventListener('shopify:block:select', (event) => {
        const cards = [...track.querySelectorAll('.carousel__slide')];
        const index = cards.indexOf(event.target.closest('.carousel__slide'));
        if (index >= 0) this.slider.selectCell(index, false, true);
      }, { signal });
      for (const img of this.querySelectorAll('img')) {
        img.addEventListener('load', () => this.slider?.resize(), { signal });
        img.addEventListener('error', () => { img.hidden = true; }, { signal });
      }
      for (const dot of this.querySelectorAll('.flickity-page-dots .dot')) {
        dot.tabIndex = 0;
        dot.setAttribute('role', 'button');
      }
      this.modals = [...this.querySelectorAll('[data-vr-modal]')];
      if (!this.modals.length) {
        for (const opener of this.querySelectorAll('modal-opener')) {
          const modal = document.querySelector(opener.dataset.modal);
          if (modal) this.modals.push(modal);
        }
      }
      if (this.modals.length) this.setupModals();
      if (this.dataset.autoMetadata === 'true') this.loadMetadata();
      document.fonts?.ready.then(() => this.slider?.resize());
    }
    syncControls(slider) {
      this.querySelector('[data-vr-rail]').dataset.overflow = String(slider.slides.length > 1);
      requestAnimationFrame(() => {
        if (!this.isConnected) return;
        for (const dot of this.querySelectorAll('.flickity-page-dots .dot')) { dot.tabIndex = 0; dot.setAttribute('role', 'button'); }
      });
      this.querySelector('[data-vr-prev]').disabled = slider.selectedIndex === 0;
      this.querySelector('[data-vr-next]').disabled = slider.selectedIndex >= slider.slides.length - 1;
    }
    async setupModals() {
      await customElements.whenDefined('modal-dialog');
      if (!this.isConnected) return;
      for (const modal of this.modals) {
        const iframe = modal.querySelector('iframe');
        const show = modal.show.bind(modal);
        const hide = modal.hide.bind(modal);
        modal.show = (opener) => {
          const source = new URL(iframe.dataset.videoSrc);
          source.searchParams.set('autoplay', '1');
          iframe.src = source.href;
          show(opener);
        };
        modal.hide = () => {
          hide();
          iframe.removeAttribute('src');
          modal.openedBy?.focus();
        };
        modal.querySelector('button').addEventListener('click', () => modal.hide(), { signal: this.events.signal });
        modal.addEventListener('keydown', (event) => {
          if (event.key !== 'Tab') return;
          const close = modal.querySelector('button');
          if (event.shiftKey && event.target === close) { event.preventDefault(); iframe.focus(); }
          else if (!event.shiftKey && event.target === iframe) { event.preventDefault(); close.focus(); }
        }, { signal: this.events.signal });
      }
    }
    async loadMetadata() {
      for (const card of this.querySelectorAll('[data-vr-card]')) {
        if (!card.dataset.url || (card.dataset.hasTitle && card.dataset.hasAuthor)) continue;
        try {
          const url = new URL('https://noembed.com/embed');
          url.searchParams.set('url', card.dataset.url);
          const response = await fetch(url, { signal: this.events.signal });
          if (!response.ok) continue;
          const data = await response.json();
          const title = data.title?.replace(/King\s*Song/gi, 'Kingsong');
          if (!card.dataset.hasTitle && title) {
            card.querySelector('[data-vr-title]').textContent = title;
            card.querySelector('[data-vr-play-label]')?.setAttribute('aria-label', title);
            const opener = card.querySelector('modal-opener');
            const modal = opener && document.querySelector(opener.dataset.modal);
            modal?.querySelector('[role="dialog"]')?.setAttribute('aria-label', title);
            modal?.querySelector('iframe')?.setAttribute('title', title);
          }
          if (!card.dataset.hasAuthor && data.author_name) {
            card.querySelector('[data-vr-author]').textContent = ' — ' + data.author_name;
            card.querySelector('[data-vr-initial]').textContent = data.author_name.replace('@', '').charAt(0).toUpperCase();
          }
          this.slider?.resize();
        } catch (error) {
          if (error.name === 'AbortError') return;
        }
      }
    }
    disconnectedCallback() {
      this.events?.abort();
      window.removeEventListener('load', this.onLoad);
      this.slider?.destroy();
      this.slider = null;
      for (const modal of this.modals || []) {
        if (modal.hasAttribute('open')) modal.hide();
        modal.remove();
      }
    }
  }
  customElements.define('ks-video-reviews', KsVideoReviews);
}



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ks-cinematic-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ks-cinematic-hero')) {
    class KsCinematicHero extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.progressBar = this.querySelector('.ks-cinematic-hero__progress-bar');
        this.currentEl = this.querySelector('[data-hero-current]');
        this.prevBtn = this.querySelector('[data-hero-prev]');
        this.nextBtn = this.querySelector('[data-hero-next]');
        this.autoplayMs = parseInt(this.dataset.autoplay, 10) || 0;
        this.currentIndex = 0;
        this.timer = null;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', () => {
            this.goTo((this.currentIndex - 1 + this.slides.length) % this.slides.length);
            this.restartAutoplay();
          });
        }

        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', () => {
            this.goTo((this.currentIndex + 1) % this.slides.length);
            this.restartAutoplay();
          });
        }

        if (this.slides.length < 2 || this.autoplayMs < 1000 || this.reducedMotion) {
          return;
        }

        this.style.setProperty('--ks-hero-duration', this.autoplayMs / 1000 + 's');
        this.addEventListener('mouseenter', () => this.pause());
        this.addEventListener('mouseleave', () => this.play());
        this.addEventListener('focusin', () => this.pause());
        this.addEventListener('focusout', () => this.play());
        this.play();
      }

      disconnectedCallback() {
        this.pause();
      }

      play() {
        this.pause();
        this.classList.add('is-playing');
        if (this.progressBar) {
          this.progressBar.style.animation = 'none';
          void this.progressBar.offsetWidth;
          this.progressBar.style.animation = '';
        }
        this.timer = window.setTimeout(() => {
          this.goTo((this.currentIndex + 1) % this.slides.length);
          this.play();
        }, this.autoplayMs);
      }

      pause() {
        this.classList.remove('is-playing');
        if (this.timer) {
          window.clearTimeout(this.timer);
          this.timer = null;
        }
      }

      goTo(index) {
        this.slides[this.currentIndex].classList.remove('is-active');
        this.currentIndex = index;
        this.slides[this.currentIndex].classList.add('is-active');

        if (this.currentEl) {
          this.currentEl.textContent = this.currentIndex + 1;
        }
      }

      restartAutoplay() {
        if (this.slides.length < 2 || this.autoplayMs < 1000 || this.reducedMotion) {
          return;
        }

        this.play();
      }
    }

    customElements.define('ks-cinematic-hero', KsCinematicHero);
  }

  } catch(e) { console.error(e); }
})();
})();
